import { render, staticRenderFns } from "./Loads.vue?vue&type=template&id=75eb9b1a&scoped=true"
import script from "./Loads.vue?vue&type=script&lang=js"
export * from "./Loads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75eb9b1a",
  null
  
)

export default component.exports